import { useAiAskBarAttachmentEffects } from './useAiAskBarAttachmentEffects'
import { useAiAskBarComposerFlags } from './useAiAskBarComposerFlags'
import { useAiAskBarConnections } from './useAiAskBarConnections'
import { useAiAskBarDerivedMemos } from './useAiAskBarDerivedMemos'
import { useAiAskBarDictationEffects } from './useAiAskBarDictationEffects'
import { useAiAskBarDictationModel } from './useAiAskBarDictationModel'
import { useAiAskBarGallery } from './useAiAskBarGallery'
import { useAiAskBarPrefillEffect } from './useAiAskBarPrefillEffect'
import { useAiAskBarState } from './useAiAskBarState'

/**
 * @param {Parameters<typeof useAiAskBarState>[0] & {
 *   prefill?: object | null,
 *   replyPreview?: object | null,
 *   sendDisabled?: boolean,
 *   onSend?: Function,
 * }} props
 */
export function useAiAskBarModel(props) {
  const state = useAiAskBarState(props)
  const flags = useAiAskBarComposerFlags({ ...props, ...state })
  const memos = useAiAskBarDerivedMemos({ variant: props.variant, isExpanded: flags.isExpanded, attachments: state.attachments, replyPreview: props.replyPreview })
  const { connectedAppsMenuItems } = useAiAskBarConnections()
  const dictation = useAiAskBarDictationModel({ isDictating: state.isDictating })
  const handleCoreUsageClick = () => {}
  const { revokePreviewUrls } = useAiAskBarAttachmentEffects({
    attachments: state.attachments,
    attachmentsRef: state.attachmentsRef,
  })
  useAiAskBarPrefillEffect({ prefill: props.prefill, ...state })
  useAiAskBarDictationEffects({ ...dictation, ...state })
  const { openAttachmentGalleryAtId } = useAiAskBarGallery({ imageAttachments: memos.imageAttachments, ...state })

  return {
    ...state,
    ...flags,
    ...memos,
    connectedAppsMenuItems,
    ...dictation,
    handleCoreUsageClick,
    revokePreviewUrls,
    openAttachmentGalleryAtId,
    // Carried on the model rather than passed down: the toolbar is eight
    // components below the root, and every level in between would grow a pair
    // of props it does nothing with. Kept separate from `sendDisabled`, which
    // also covers an open agent question — nothing there is stoppable.
    isGenerating: Boolean(props.isGenerating),
    onStopGenerating: props.onStopGenerating,
  }
}
